
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import LogoutLink from '../../components/auth/LogoutLink';

const NoAccessPage = () => {

    const classNames = mergeStyleSets({
        NoAccessPage: {
        },
        info: {
            paddingTop: 8
        },
        logout: {
            paddingTop: 32
        }
    });

    const user = useSelector(state => {
        return state.auth.data ? state.auth.data.user : null;
    });
    const appProjectId = useSelector(state => {
        return state.app.projectId;
    });

    return (
        <Stack className={classNames.NoAccessPage}>
            <div className={classNames.info}>Nemáte dostatečná oprávnění pro přístup k této aplikaci.</div>
            {(!!user)
                ? <>
                    <div className={classNames.info}>Aktuálně přihlášený uživatel <b>{user.fullName} ({user.username})</b> z domény <b>{user.projectId}</b></div>
                    <div className={classNames.info}>Je potřeba se přihlásit účtem z domény <b>{appProjectId}</b></div>

                </>
                : null
            }
            <div className={classNames.logout}>
                <LogoutLink
                    logoutUrl=""
                />
            </div>
        </Stack>
    );
}

export default NoAccessPage;
